import {
  getTableNames,
  mapTablesToSelection,
} from 'new/components/flows/types/cdc/CreateCDCFlow/ResourceSetupPage/getTablesFromResource';
import { getMapping } from 'new/components/flows/types/cdc/CreateCDCFlow/ResourceSetupPage/getMappings';
import { UiMode } from 'new/constants/uiMode';

export const mapToSinkConfig = (config) => {
  const sink = {
    name: config.name,
    description: config.description,
    sink_config: {
      ['cdc.enabled']: true,
      ['cdc.mode']: 'multi_table',
      ...(config['ui.mode'] ? { ['ui.mode']: config['ui.mode'] } : {}),
    },
  };

  if (config.namespace) {
    sink.sink_config['database'] = config.namespace;
  }
  sink.sink_config['mapping'] = {
    mode: config.schemaMode !== 'name' ? 'auto' : 'manual',
    replay_row_deletions: config.captureDelete,
    table_name_prefix: config.tablePrefix,
    table_name_suffix: config.tableSuffix,
    tracker_name: config.trackerEnabled ? config.trackerName || '__nexla_tracker_id' : '',
    tracker_mode: config.trackerEnabled ? 'RECORD' : 'NONE',
  };
  if (config.schemaMode === 'name') {
    sink.sink_config['mapping']['exclude_tables'] = getTableNames(config.selection);
  }
  if (Object.values(config?.mapping || {}).length) {
    sink.sink_config['mapping']['overridden_mappings'] = getMapping(config.mapping);
  }
  return sink;
};

type MappingType = Record<string, string[]>;

export const getReverseMapping = (mapping: Record<string, { columns: string[] }>) => {
  if (!mapping) return null;

  return Object.keys(mapping).reduce((reverseMapping, tableName) => {
    const columns = mapping[tableName]?.columns || [];
    reverseMapping[tableName] = columns;
    return reverseMapping;
  }, {} as MappingType);
};

export const parseSinkConfig = (sink) => {
  const sinkConfig = sink?.sink_config;
  const config = {
    name: sink.name,
    description: sink['description'],
    namespace: sinkConfig?.['database'] || undefined,
    schemaMode: sinkConfig?.['mapping']?.mode !== 'auto' ? 'name' : 'auto',
    captureDelete: sinkConfig?.['mapping']?.replay_row_deletions || false,
    tablePrefix: sinkConfig?.['mapping']?.table_name_prefix || '',
    tableSuffix: sinkConfig?.['mapping']?.table_name_suffix || '',
    trackerEnabled: sinkConfig?.['mapping']?.tracker_mode === 'RECORD' || false,
    trackerName: sinkConfig?.['mapping']?.tracker_name || '',
    ...(sinkConfig?.['ui.mode'] ? { ['ui.mode']: sinkConfig['ui.mode'] } : {}),
    mapping: {},
    selection: {},
  };

  if (config.schemaMode === 'name') {
    config.selection = mapTablesToSelection(sinkConfig['mapping']?.exclude_tables);
  }

  if (sinkConfig['mapping']?.overridden_mappings) {
    config.mapping = getReverseMapping(sinkConfig['mapping']?.overridden_mappings);
  }

  return config;
};
